import React, {useEffect} from 'react';
import { formatNumber } from '../../../../utils/tools'
import { InputContainer } from '../../DepositElements'

const DatosUsdtBinance = ({form, setForm, handleChange}) => {
  useEffect(()=>{
    setForm({...form, numeroCuenta:'',  monto2:''});
  },[]);

  const acceptOnly2Digits = (e) => {
    let value = e.target.value;
    value = value.replace(/\D/g, "");
    e.target.value = value;
    return e;
  }

  return (
    <>
    <InputContainer>
        <label>CORREO:</label>
        <input type='text' name='numeroCuenta' placeholder='ejemplo@mail.com' value={form.numeroCuenta} onChange={handleChange} required />
      </InputContainer>
      <InputContainer>
        <label>ÚLTIMOS DOS (2) DÍGITOS BINANCE ID:</label>
        <input type='text' name='ultimosDigitos' value={form.ultimosDigitos} placeholder='Ingrese los últimos dos (2) dígitos binance ID' maxLength={2} pattern="^\d{2}$" onChange={(e)=>handleChange(acceptOnly2Digits(e))} required/>
      </InputContainer>
      <InputContainer>
        <label>MONTO:</label>
        <input type='text' name='monto2' value={form.monto2} placeholder='0,00' onChange={(e)=>handleChange(formatNumber(e))} required/>
      </InputContainer>
    </>
  )
}

export default DatosUsdtBinance